import { AccountDetailsStepConfig, PreviewAccountStepConfig } from './steps/account-details/account-details-step-config';
import { CampaignModeStepConfig } from './steps/campaign-mode/campaign-mode-step-config';
import { AdAssetsStepConfig } from './steps/ad-assets/ad-assets-step-config';
import { BudgetStepConfig } from './steps/budget/budget-step-config';
import { CampaignCreationMethodStepConfig } from './steps/campaign-creation-method/campaign-creation-method-step-config';
import { FacebookImportStepConfig } from './steps/facebook-import/facebook-import-step-config';
import { GoogleImportStepConfig } from './steps/google-import/google-import-step-config';
import { LanguageCountryStepConfig } from './steps/language-country/language-country-step-config';
import { PaymentStepConfig, PreviewPaymentStepConfig } from './steps/payment-step/payment-step-config';
import { AddFundsStepConfig, PreviewAddFundsStepConfig } from './steps/add-funds-step/add-funds-step-config';
import { SmartPageCustomDomainStepConfig } from './steps/smart-page-custom-domain/smart-page-custom-domain-step-config';
import { SmartPageEditorStepConfig } from './steps/smart-page-editor/smart-page-editor-step-config';
import { SmartPageSignupStepConfig } from './steps/smart-page-signup/smart-page-signup-step-config';
import { TargetingStepConfig } from './steps/targeting/targeting-step-config';
import { WebsiteStepConfig } from './steps/website/website-step-config';
import { ConversionUpsellStepConfig } from './steps/conversion-upsell/conversion-upsell-step-config';
import { PreviewAssetsStepConfig } from './steps/preview-assets/preview-assets-step-config';
import { SDKImportCompleteStepConfig } from './steps/sdk-import-complete/sdk-import-complete-step-config';
import { CollectBusinessInfoPlaceholderStepConfig } from './steps/collect-business-info/campaign-creation-placeholder-step-config';
import { ChinaDomesticStepConfig } from './steps/china-domestic/china-domestic-step-config';
import { CatalogFeedSelectionStepConfig } from './steps/catalog-feed-selection-step/catalog-feed-selection-step-config';
import { ChannelSelectionStepConfig } from './steps/channel-selection-step/channel-selection-step-config';
import { AllCampaignTypeSelectionStepConfig } from './steps/all-campaign-type-selection-step/all-campaign-type-selection-step-config';
import { CampaignGoalSelectionStepConfig } from './steps/campaign-goal-selection-step/campaign-goal-selection-step-config';
import { CampaignCreationMethodSelectionStepConfig } from './steps/campaign-creation-method-selection-step/campaign-creation-method-selection-step-config';
import { SearchCampaignSettingsStepConfig } from './steps/search-campaign-settings/search-campaign-settings-step-config';
import {
  SearchCampaignKeywordsStepConfig
} from './steps/search-campaign-keywords/search-campaign-keywords-step-config';
import {
  SearchCampaignAddTextStepConfig
} from './steps/search-campaign-add-text/search-campaign-add-text-step-config';
import {
  SearchCampaignAddMoreAssetsStepConfig
} from './steps/search-campaign-add-more-assets/search-campaign-add-more-assets-step-config';
import {
  SearchCampaignBudgetAndBidsStepConfig
} from './steps/search-campaign-budget-bids/search-campaign-budget-bids-step-config';
import { AgenticAnalyzeStepConfig } from './steps/agentic-analyze/agentic-analyze-step-config';
import { AgenticSnapshotReviewStepConfig } from './steps/agentic-snapshot-review/agentic-snapshot-review-step-config';
import { CampaignDraftStepConfig } from './steps/campaign-draft/campaign-draft-step-config';
import { CampaignDraftAssetsStepConfig } from './steps/campaign-draft/campaign-draft-assets-step-config';
import { CampaignDraftBudgetStepConfig } from './steps/campaign-draft/campaign-draft-budget-step-config';
import { CampaignDraftTargetingStepConfig } from './steps/campaign-draft/campaign-draft-targeting-step-config';

export const StepConfig = [
  CampaignCreationMethodStepConfig,
  LanguageCountryStepConfig,
  WebsiteStepConfig,
  GoogleImportStepConfig,
  FacebookImportStepConfig,
  SmartPageSignupStepConfig,
  SmartPageEditorStepConfig,
  SmartPageCustomDomainStepConfig,
  CampaignModeStepConfig,
  AdAssetsStepConfig,
  TargetingStepConfig,
  BudgetStepConfig,
  PreviewAssetsStepConfig,
  AccountDetailsStepConfig,
  PaymentStepConfig,
  AddFundsStepConfig,
  PreviewAccountStepConfig,
  PreviewPaymentStepConfig,
  PreviewAddFundsStepConfig,
  ConversionUpsellStepConfig,
  SDKImportCompleteStepConfig,
  CollectBusinessInfoPlaceholderStepConfig,
  ChinaDomesticStepConfig,
  CatalogFeedSelectionStepConfig,
  ChannelSelectionStepConfig,
  AllCampaignTypeSelectionStepConfig,
  CampaignGoalSelectionStepConfig,
  CampaignCreationMethodSelectionStepConfig,
  SearchCampaignSettingsStepConfig,
  SearchCampaignKeywordsStepConfig,
  SearchCampaignAddTextStepConfig,
  SearchCampaignAddMoreAssetsStepConfig,
  SearchCampaignBudgetAndBidsStepConfig,
  AgenticAnalyzeStepConfig,
  AgenticSnapshotReviewStepConfig,
  CampaignDraftStepConfig,
  CampaignDraftAssetsStepConfig,
  CampaignDraftBudgetStepConfig,
  CampaignDraftTargetingStepConfig,
];
